import { render, staticRenderFns } from "./ProviderReport.vue?vue&type=template&id=67e55642&scoped=true&"
import script from "./ProviderReport.vue?vue&type=script&lang=ts&"
export * from "./ProviderReport.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderReport.vue?vue&type=style&index=0&id=67e55642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e55642",
  null
  
)

export default component.exports